module.exports = __webpack_public_path__ + "web/img/wav.8d929590.png";